<template>
  <div class="menu">
    <div class="menu__panel">
      <div class="panel">
        <div class="panel__header menu-sub">
          <p>Past exam questions</p>
        </div>
        <div class="panel__body">
          <div class="panel__content">
            <ul class="items">
               <li class="item study-exam" :class="{isLock:isLock[0], isPassed:isPassed[0]}">
                <div class="item__inner" v-on:click="gotoTest(1)">
                  <p>2018<br>Written exam A ①</p>
                </div>
              </li>
              <li class="item study-exam" :class="{isLock:isLock[1], isPassed:isPassed[1]}">
                <div class="item__inner" v-on:click="gotoTest(2)">
                  <p>2018<br>Written exam A ②</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="menu__return">
      <div v-on:click="onReturn()" class="modal-box__return">
        <img :src="`${staticPath}img/factory/btn_return.png`">
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  @import '@/assets/scss/study_menu.scss';

  .menu__panel {
    height: auto;
  }

  .panel__header.menu-sub {

    &::before {
      background-image: url($static-path + 'img/factory/study/icon_exam_wht.png');
    }

    >p {
      padding-left: 6px;
    }
  }
</style>

<script>
  import Constant from '@/constant';

  export default {
    name: 'MenuExam2',

    data() {
      return {
        staticPath: Constant.STATICPATH,
        isLock: [],
        isPassed: []
      }
    },

    created() {

      // 初期化
      this.isLock[0] = false;
      this.isLock[1] = true;
      this.isPassed[0] = false;
      this.isPassed[1] = false;

      // 試験の合格具合でメニューの表示変更
      const passed_items = this.$store.getters['PassedTest/items'];
      const passed_num = passed_items.length;

      for (let i=0; i < passed_num; i++) {

        const item = passed_items[i];

        if (item.testType == 'exam') {

          if (item.testId == 1) {

            this.isLock[1] = false;
            this.isPassed[0] = true;

          } else if (item.testId == 2) {

            this.isLock[1] = false;
            this.isPassed[0] = true;
            this.isPassed[1] = true;
          }
        }
      }
    },

    methods: {

      gotoTest(exam_id) {

        this.$emit('goto-test-exam', exam_id);
      },

      onReturn() {
        this.$emit('on-return');
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Study/MenuExam2.vue